const helpers = Object.freeze({
    isPhone: () => {
        return helpers.isMobile() && !helpers.isIPad();
    },
    isMobile: () => {
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream)
        ) {
            return true;
        }
        return false;
    },
    matchesHideMobileMediaQuery: () => {
        return window.matchMedia('screen and (((min-width: 568px) and (orientation: landscape)) or (min-width: 768px))')
            .matches;
    },
    isIPad: () => {
        if (
            /iPad/i.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream)
        ) {
            return true;
        }
    },
    isPortrait: () => {
        return window.matchMedia('(orientation: portrait)').matches;
    },
    waitForElem: (elem, selector) => {
        return new Promise((resolve) => {
            if (elem.querySelector(selector)) {
                return resolve(elem.querySelector(selector));
            }

            const observer = new MutationObserver(() => {
                if (elem.querySelector(selector)) {
                    resolve(elem.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(elem, {
                childList: true,
                subtree: true,
            });
        });
    },
    onOrientationChange: (callback) => {
        window.addEventListener('orientationchange', () => {
            const afterOrientationChange = () => {
                callback();
                window.removeEventListener('resize', afterOrientationChange);
            };

            window.addEventListener('resize', afterOrientationChange);
        });
    },
    waitForElement(selector) {
        return new Promise((resolve) => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(() => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
            });
        });
    },
});

const exposeHelpers = () => {
    (window.isMobile = helpers.isMobile), (window.isPhone = helpers.isPhone);
};

(function () {
    exposeHelpers();
})();

export { helpers };
